import { StarCircleSVG } from "@components/svgs/star-circle";
import { DELAY_TIME } from "@constants";
import { IconButton, Tooltip, tooltipClasses, useTheme } from "@mui/material";
import { hexToRGBA } from "@utils";

export interface FavouritedButtonV2Props {
  width?: number;
  height?: number;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  isFavourited?: boolean;
}

export const FavouritedButtonV2 = ({
  width = 24,
  height = 24,
  disabled,
  isFavourited,
  onClick,
}: FavouritedButtonV2Props) => {
  const { shadows, palette } = useTheme();
  return (
    <Tooltip
      title="Favourite"
      enterDelay={DELAY_TIME}
      enterNextDelay={DELAY_TIME}
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
              {
                marginTop: "6px",
              },
          },
        },
      }}
      sx={{
        width,
        height,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <IconButton
        disableRipple
        disabled={disabled}
        onClick={onClick}
        sx={{
          width,
          height,
          p: 0,
          backgroundColor: isFavourited
            ? hexToRGBA(palette.error.main, 0.1)
            : palette.common.white,
          boxShadow: shadows[1],
          "&>svg>path": {
            fill: isFavourited
              ? palette.common.cadmiumYellow
              : palette.common.white,
            stroke: isFavourited
              ? palette.warning[800]
              : hexToRGBA(palette.error.main, 0.5),
          },
          "&>svg>circle": {
            stroke: palette.error[100],
          },
          "&:hover": {
            backgroundColor: hexToRGBA(palette.error.main, 0.1),
            boxShadow: "none",
            "&>svg>path": {
              fill: palette.common.cadmiumYellow,
              stroke: palette.warning[800],
            },
            "&>svg>circle": {
              stroke: hexToRGBA(palette.error.main, 0.2),
            },
          },
          "&:active": {
            backgroundColor: hexToRGBA(palette.error.main, 0.1),
            boxShadow: `inset 3px 3px 4px ${hexToRGBA(
              palette.common.black,
              0.25,
            )}`,
            "&>svg>path": {
              fill: palette.common.cadmiumYellow,
              stroke: palette.warning[800],
            },
            "&>svg>circle": {
              stroke: hexToRGBA(palette.error.main, 0.2),
            },
          },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <StarCircleSVG width={24} height={24} />
      </IconButton>
    </Tooltip>
  );
};
